import React from 'react';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import BottomSheet from 'components/BottomSheet';
import useIsDesktop from 'hooks/useIsDesktop';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Title, Content, ButtonContainer, CancelButton, ConfirmButton } from './styles';

export interface Props {
  show: boolean;
  confirmText?: string;
  red?: boolean;
  title?: string;
  content?: any;
  onClose?: () => void;
  onConfirm?: () => void;
  confirmLoading?: boolean;
  closeLoading?: boolean;
  autoClose?: boolean;
}

interface ConfirmProps {
  title?: string;
  content: any;
  confirmText?: string;
  handleConfirm?: () => void;
  handleClose?: () => void;
  red?: boolean;
  confirmLoading?: boolean;
  closeLoading?: boolean;
  autoClose?: boolean;
}

const ConfirmContent = ({
  title,
  content,
  confirmText,
  handleConfirm,
  handleClose,
  red,
  confirmLoading,
  closeLoading,
  autoClose,
}: ConfirmProps) => {
  const { t } = useStoreTranslation();

  const onClick = () => {
    if (handleClose) handleClose();
  };

  return (
    <>
      <Title>{title}</Title>
      <Content>{content}</Content>
      <ButtonContainer>
        {handleClose && (
          <CancelButton invertedColor type="button" onClick={onClick} loading={closeLoading} disabled={closeLoading}>
            {t('confirmBottomSheet.cancelButton')}
          </CancelButton>
        )}
        <ConfirmButton
          red={red}
          type="button"
          value={confirmText || t('confirmBottomSheet.confirmButton')}
          onClick={
            handleConfirm
              ? () => {
                  handleConfirm();
                  if (autoClose && handleClose) handleClose();
                }
              : () => {}
          }
          fullWidth={!handleClose}
          loading={confirmLoading}
          disabled={confirmLoading}
        />
      </ButtonContainer>
    </>
  );
};

const ConfirmBottomSheet = ({
  show,
  onClose,
  title,
  content = '',
  onConfirm,
  red,
  confirmText,
  confirmLoading,
  closeLoading,
  autoClose = true,
}: Props) => {
  const isDesktop = useIsDesktop();

  const handleClose = () => {
    if (onClose) onClose();
  };

  if (isDesktop) {
    return (
      <ApplicationOverlayContent show={show} onClose={handleClose}>
        <ConfirmContent
          title={title}
          content={content}
          confirmText={confirmText}
          handleConfirm={onConfirm}
          handleClose={onClose}
          red={red}
          confirmLoading={confirmLoading}
          closeLoading={closeLoading}
          autoClose={autoClose}
        />
      </ApplicationOverlayContent>
    );
  }

  return (
    <BottomSheet show={show} onClose={handleClose} noHeader noPadding>
      <Container>
        <ConfirmContent
          title={title}
          content={content}
          confirmText={confirmText}
          handleConfirm={onConfirm}
          handleClose={onClose}
          red={red}
          autoClose={autoClose}
        />
      </Container>
    </BottomSheet>
  );
};

export default ConfirmBottomSheet;
